import { render, staticRenderFns } from "./DeleteDnsZoneDialog.vue?vue&type=template&id=63373689&"
import script from "./DeleteDnsZoneDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteDnsZoneDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports